import { Container } from "@mui/system";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./Banner.module.css";
import right_arrow from "assets/images/right-arrow.svg";
import right_arrow_white from "assets/images/right-arrow-white.svg";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import AppButton from "../button/AppButton";
import banner_img from "assets/images/banner-img.png";
import bg_img from "assets/images/banner-layout.svg";
import suitcase_icon from "assets/images/suitcase.svg";
import chart_icon from "assets/images/chart.svg";
import clock_icon from "assets/images/clock.svg";

function Banner() {
  return (
    <div className={styles.banner}>
      <Container maxWidth="lg">
        <div className={styles.banner_content}>
          {/* <div className={styles.heading}>
            <Container maxWidth="sm">
              <div className={styles.heading_content}>
                <div className={styles.links}>
                  <a href="/">
                    Home <img src={right_arrow} alt="" />
                  </a>
                  <a href="/">
                    Products and Services <img src={right_arrow} alt="" />
                  </a>
                  <a href="/">
                    Loans <img src={right_arrow} alt="" />
                  </a>
                </div>
                <Typography>Home Loan Application</Typography>
              </div>
            </Container>
          </div> */}
          <div
            style={{
              textAlign: "center",
              marginBottom: "1rem",
              color: "#073CAE",
            }}
          >
            <Typography
              style={{ fontSize: "36px", fontWeight: "600" }}
              variant="h5"
            >
            Home Loans
            </Typography>
          </div>
          <div className={styles.body}>
            <div className={styles.background_img}>
              <img src={bg_img} alt="" />
            </div>
            <Container maxWidth='lg'>
              <Grid  container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <div className={styles.left}>
                    <Typography variant="h6">
                      Get your Mortgage today!
                    </Typography>
                    <Typography>
                      Browse for your choice property, schedule inspections, get
                      pre-qualified and apply for a mortgage without visiting
                      any of our branches.
                    </Typography>
                    {/* <Link to="/prequalification">
                    <AppButton
                      icon={right_arrow_white}
                      btnBg="#0072CE"
                      width={"207px"}
                      textColor="#ffffff"
                      btnText="PreQualification"
                    />
                  </Link> */}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className={styles.right}>
                    {/* <div className={`${styles.banner_pill} ${styles.pill1}`}>
                    <img src={clock_icon} alt="" />
                    <Typography>
                      Go from App view to inspection in 2 min
                    </Typography>
                  </div>
                  <div className={`${styles.banner_pill} ${styles.pill2}`}>
                    <img src={suitcase_icon} alt="" />
                    <Typography>Close 10 days faster</Typography>
                  </div>
                  <div className={`${styles.banner_pill} ${styles.pill3}`}>
                    <img src={chart_icon} alt="" />
                    <Typography>Get to 91% conversion rate</Typography>
                  </div> */}
                    <img src={banner_img} alt="" />
                  </div>
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Banner;
